import { useSyncExternalStore } from 'react';

const TOKEN_KEY = 'uncle-ads-token';

let token: string | null =
  typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(TOKEN_KEY) : null;

const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) {
    listener();
  }
}

export function getAuthToken(): string | null {
  return token;
}

export function setAuthToken(next: string | null): void {
  token = next;
  if (next) sessionStorage.setItem(TOKEN_KEY, next);
  else sessionStorage.removeItem(TOKEN_KEY);
  emit();
}

export function subscribeAuthToken(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useAuthToken(): string | null {
  return useSyncExternalStore(subscribeAuthToken, getAuthToken, () => null);
}
